import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate';

import { IconsModule } from '../icons/icons.module';
import { ExpandModule } from '../expand/expand.module';
import { ImagesModule } from '../images/images.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { TripCardComponent } from './trip-card/trip-card.component';
import { FlightCardComponent } from './flight-card/flight-card.component';
import { UnifiedFlightObjectComponent } from './unified-flight-object/unified-flight-object.component';
import { TimelineComponent } from './timeline/timeline.component';
import { ChipModule } from '../chip';

@NgModule({
  declarations: [TripCardComponent, FlightCardComponent, UnifiedFlightObjectComponent, TimelineComponent],
  imports: [CommonModule, IconsModule, UiTranslateModule, NotificationsModule, ExpandModule, ImagesModule, ChipModule],
  exports: [TripCardComponent, FlightCardComponent, UnifiedFlightObjectComponent, TimelineComponent],
  providers: [],
})
export class FlightsModule {}
